
import { api } from "@api/api";
import { appConfig } from "@core/configs/appConfig";
import type { AuthProvider } from "@refinedev/core";

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    if (username && password) {
      try {
        const response = await api.post("v1/users/tokens/", {
          username,
          password,
        });

        const { token } = response.data;

        localStorage.setItem(appConfig.auth.storageKey, token);

        return {
          success: true,
          redirectTo: "/",
        };
      } catch ({ response: { data } }: any) {
        return {
          success: false,
          error: {
            name: "LoginError",
            message: data.error,
          },
        };
      }
    }

    return {
      success: false,
      error: {
        name: "LoginError",
        message: "Invalid username or password",
      },
    };
  },

  logout: async () => {
    localStorage.removeItem(appConfig.auth.storageKey);

    return {
      success: true,
      redirectTo: "/login",
    };
  },

  check: async () => {
    const auth = localStorage.getItem(appConfig.auth.storageKey);

    if (auth) {
      return {
        authenticated: true,
      };
    }

    return {
      authenticated: false,
      redirectTo: "/login",
    };
  },

  getPermissions: async () => {
    return null;
  },

  getIdentity: async () => {
    const token = localStorage.getItem(appConfig.auth.storageKey);

    if (token) {
      try {
        const response = await api.get("v1/profile/");
        return response.data;

      } catch (error) {
        console.error("Failed to decode token or fetch profile:", error);
      }
    }

    return null;
  },

  onError: async (error) => {
    console.error(error);
    return { error };
  },
};
